export default __webpack_public_path__ + "static/media/Clasp of Revival.f27ce3c0.jpg";